import { FC, useReducer, ChangeEvent, useEffect } from 'react';
import { Container } from './MyDataAdmin.styles';
import { Button, Input, Section } from '../../../../components';
import { SaveOutlined } from '@mui/icons-material';
import { useToastStore, useUserStore } from '../../../../stores';
import { Form, SectionTitle, Separator } from '../../MyAccount.styles';
import { adminDataInitialState, adminDataReducer } from './forms/adminData.form';
import { TUser, putUser } from '../../../../services';

const MyDataAdmin: FC = () => {
	const { user, setUser } = useUserStore();
	const { setToast } = useToastStore();
	const [adminDataState, adminDataDispatch] = useReducer(adminDataReducer, adminDataInitialState);

	const handleAdminDataInputChange = (e: ChangeEvent<HTMLInputElement>): void => {
		const { name, value } = e.target;
		adminDataDispatch({ type: 'SET_FIELD_VALUE', field: name, payload: value });
	};

	const handleUpdateBasicData = async () => {
		const body: TUser = {
			...user!,
			nome: adminDataState.nome,
			email: adminDataState.email,
			telefone: adminDataState.telefone,
		};

		try {
			await putUser(body);
			setUser(body);
			setToast({ message: 'Dados atualizados com sucesso!', variant: 'success' });
		} catch {
			setToast({ message: 'Erro ao atualizar dados!', variant: 'error' });
		}
	};

	useEffect(() => {
		if (!user) return;

		const newShopkeeperState = { nome: user.nome, telefone: user.telefone, email: user.email };
		adminDataDispatch({ type: 'REPLACE_STATE', payload: newShopkeeperState });
	}, [user]);

	return (
		<Container>
			<Section>
				<SectionTitle>Meus dados</SectionTitle>
				<Separator />
				<Form>
					<Input
						variant='text'
						label='Nome'
						className='full-line'
						value={adminDataState.nome}
						name='nome'
						onChange={handleAdminDataInputChange}
					/>
					<Input
						variant='text'
						label='Login/E-mail'
						className='left-half'
						value={adminDataState.email}
						name='email'
						onChange={handleAdminDataInputChange}
					/>
					<Input
						variant='text'
						label='Telefone'
						className='right-half'
						value={adminDataState.telefone}
						name='telefone'
						onChange={handleAdminDataInputChange}
					/>
					<Button
						variant='contained'
						onClick={handleUpdateBasicData}
						fitContent
						disabled={!adminDataState.nome || !adminDataState.email || !adminDataState.telefone}
					>
						<SaveOutlined fontSize='medium' />
						<span>Salvar</span>
					</Button>
				</Form>
			</Section>
		</Container>
	);
};

export default MyDataAdmin;
